<template>
	<div class="shadow_bg" id="area_dialog">
		<div class="windows_table" :style="{ top: top + 'px' }">
			<div class="close_btn" @click="close_window"><img src="../../assets/img/close_icon.png"></div>
			<div class="opentab-header">{{ title }}</div>
			<div class="count_tip" v-if="show">共 {{ total }} 条数据</div>
			<div class="open_table" id="area_edu_table" v-on:scroll="scrollLoad">
				<table class="pure-table">
					<thead id="area_edu_thead"></thead>
					<tbody id="area_edu_tbody"></tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
var storage = window.localStorage;
var orgCode = storage.getItem("orgCode");
export default {
	data() {
		return {
			top: 0,
			title: '',
			type: '',
			total: 0,
			show: false,
			loadingFlag: true,
			pageIndex: 1,
			pageSize: 10
		}
	},
	mounted() {
		this.top = (document.body.clientHeight - 700) / 2;
		let _this = this;
		window.onresize = function () { // 定义窗口大小变更通知事件
			_this.top = (document.documentElement.clientHeight - 700) / 2;
		}
	},
	watch: {
		'top': function () { //监听屏幕高度变化
			this.top = (document.body.clientHeight - 700) / 2;
		}
	},
	methods: {
		//div滚动事件
		scrollLoad() {
			if (this.loadingFlag) {
				let element = document.getElementById('area_edu_table');
				var divHeight = element.offsetHeight;		//div高度
				var scrollHeight = element.scrollTop;		//滚动高度
				var contentHeight = element.scrollHeight;	//div内容高度
				if (divHeight + scrollHeight >= contentHeight) {		// div高度+滚动高度 >= div内容高度-（padding和margin所占的高度）
					this.loadingFlag = false;
					this.refreshData();
				}
			}
		},
		initData(title, type) {
			this.title = title;
			this.type = type;
			this.pageIndex = 1;
			//填充表格头
			let element = document.getElementById('area_edu_thead');
			if (this.type == "stuLeave") {
				element.innerHTML = '<tr><th>学校</th><th>班级</th><th>姓名</th><th>请假类型</th></tr>';
			} else if (this.type == "teaLeave") {
				element.innerHTML = '<tr><th>学校</th><th>姓名</th><th>手机号</th><th>请假类型</th></tr>';
			} else if (this.type == "stuAttend") {
				element.innerHTML = '<tr><th>学校</th><th>班级</th><th>姓名</th></tr>';
			} else if (this.type == "teaAttend") {
				element.innerHTML = '<tr><th>学校</th><th>姓名</th><th>手机号</th></tr>';
			} else if (this.type == "visitInfo") {
				element.innerHTML = '<tr><th>学校</th><th>访客姓名</th><th>到访时间</th></tr>';
			}
			//加载数据			
			this.refreshData();
		},
		refreshData() {
			let _this = this;
			if (_this.pageIndex == 1) {
				document.getElementById('area_edu_tbody').innerHTML = '';
			}
			if (_this.type == "stuLeave") {
				this.$http.get("/dataView/platform/getStuLeaveRecordByToday?orgCode=" + orgCode + "&page=" + _this.pageIndex + "&rows=" + _this.pageSize).then(res => {
					if (res.data.code === 200) {
						let element = document.getElementById('area_edu_tbody');
						if (res.data.totalRow > 0) {
							for (var i = 0; i < res.data.result.length; i++) {
								var obj = res.data.result[i];
								var html = '<tr><td>' + obj.orgName + '</td><td>' + obj.clazzName + '</td><td>' + obj.studentName + '</td><td>' + obj.leaveType + '</td></tr>';
								let appendElement = document.createElement("tr");
								appendElement.innerHTML = html;
								element.append(appendElement);
							}
							_this.show = true;
							_this.total = res.data.totalRow;
							//如果滑动到最后一页，锁定加载数据
							if (Math.ceil(_this.total/_this.pageSize) == _this.pageIndex) {
								_this.loadingFlag = false;
							} else {
								_this.loadingFlag = true;
							}
						} else {
							_this.loadingFlag = false;
							_this.show = false;
							document.getElementById('area_edu_table').innerHTML = '<div class="none_data"><img src="' + require("../../assets/img/none_icon.png") + '"><p style="color: #49b9ff">暂无数据</p></div>';
						}
						_this.pageIndex = _this.pageIndex + 1;
					}
				})
			} else if (_this.type == "teaLeave") {
				this.$http.get("/dataView/platform/getTeaLeaveRecordByToday?orgCode=" + orgCode + "&page=" + _this.pageIndex + "&rows=" + _this.pageSize).then(res => {
					if (res.data.code === 200) {
						let element = document.getElementById('area_edu_tbody');
						if (res.data.result.length > 0) {
							for (var i = 0; i < res.data.result.length; i++) {
								var obj = res.data.result[i];
								var html = '';
								if(obj.telephone){
									html = '<tr><td>' + obj.orgName + '</td><td>' + obj.teacherName + '</td><td>' + obj.telephone + '</td><td>' + obj.leaveType + '</td></tr>';
								}else{
									html = '<tr><td>' + obj.orgName + '</td><td>' + obj.teacherName + '</td><td></td><td>' + obj.leaveType + '</td></tr>';
								}
								let appendElement = document.createElement("tr");
								appendElement.innerHTML = html;
								element.append(appendElement);
							}
							_this.show = true;
							_this.total = res.data.totalRow;
							//如果滑动到最后一页，锁定加载数据
							if (Math.ceil(_this.total/_this.pageSize) == _this.pageIndex) {
								_this.loadingFlag = false;
							} else {
								_this.loadingFlag = true;
							}
						} else {
							_this.loadingFlag = false;
							_this.show = false;
							document.getElementById('area_edu_table').innerHTML = '<div class="none_data"><img src="' + require("../../assets/img/none_icon.png") + '"><p style="color: #49b9ff">暂无数据</p></div>';
						}
						_this.pageIndex = _this.pageIndex + 1;
					}
				})
			} else if (_this.type == "stuAttend") {
				this.$http.get("/dataView/platform/getStuAttendRecordByToday?orgCode=" + orgCode + "&page=" + _this.pageIndex + "&rows=" + _this.pageSize).then(res => {
					if (res.data.code === 200) {
						let element = document.getElementById('area_edu_tbody');
						if (res.data.result.length > 0) {
							for (var i = 0; i < res.data.result.length; i++) {
								var obj = res.data.result[i];
								var html = '<tr><td>' + obj.orgName + '</td><td>' + obj.clazzName + '</td><td>' + obj.studentName + '</td></tr>';
								let appendElement = document.createElement("tr");
								appendElement.innerHTML = html;
								element.append(appendElement);
							}
							_this.show = true;
							_this.total = res.data.totalRow;
							//如果滑动到最后一页，锁定加载数据
							if (Math.ceil(_this.total/_this.pageSize) == _this.pageIndex) {
								_this.loadingFlag = false;
							} else {
								_this.loadingFlag = true;
							}
						} else {
							_this.loadingFlag = false;
							_this.show = false;
							document.getElementById('area_edu_table').innerHTML = '<div class="none_data"><img src="' + require("../../assets/img/none_icon.png") + '"><p style="color: #49b9ff">暂无数据</p></div>';
						}
						_this.pageIndex = _this.pageIndex + 1;
					}
				})
			} else if (_this.type == "teaAttend") {
				this.$http.get("/dataView/platform/getTeaAttendRecordByToday?orgCode=" + orgCode + "&page=" + _this.pageIndex + "&rows=" + _this.pageSize).then(res => {
					if (res.data.code === 200) {
						let element = document.getElementById('area_edu_tbody');
						if (res.data.result.length > 0) {
							for (var i = 0; i < res.data.result.length; i++) {
								var html = '';
								var obj = res.data.result[i];
								if(obj.telephone){
									html = '<tr><td>' + obj.orgName + '</td><td>' + obj.teacherName + '</td><td>' + obj.telephone + '</td></tr>';
								}else{
									html = '<tr><td>' + obj.orgName + '</td><td>' + obj.teacherName + '</td><td></td></tr>';
								}
								let appendElement = document.createElement("tr");
								appendElement.innerHTML = html;
								element.append(appendElement);
							}
							_this.show = true;
							_this.total = res.data.totalRow;
							//如果滑动到最后一页，锁定加载数据
							if (Math.ceil(_this.total/_this.pageSize) == _this.pageIndex) {
								_this.loadingFlag = false;
							} else {
								_this.loadingFlag = true;
							}
						} else {
							_this.loadingFlag = false;
							_this.show = false;
							document.getElementById('area_edu_table').innerHTML = '<div class="none_data"><img src="' + require("../../assets/img/none_icon.png") + '"><p style="color: #49b9ff">暂无数据</p></div>';
						}
						_this.pageIndex = _this.pageIndex + 1;
					}
				})
			} else if (_this.type == "visitInfo") {
				this.$http.get("/dataView/platform/getVisitorRecordByToday?orgCode=" + orgCode + "&page=" + _this.pageIndex + "&rows=" + _this.pageSize).then(res => {
					if (res.data.code === 200) {
						let element = document.getElementById('area_edu_tbody');
						if (res.data.result.length > 0) {
							for (var i = 0; i < res.data.result.length; i++) {
								var obj = res.data.result[i];
								var html = '<tr><td>' + obj.orgName + '</td><td>' + obj.visitorName + '</td><td>' + obj.visitorTime + '</td></tr>';
								let appendElement = document.createElement("tr");
								appendElement.innerHTML = html;
								element.append(appendElement);
							}
							_this.show = true;
							_this.total = res.data.totalRow;
							//如果滑动到最后一页，锁定加载数据
							if (Math.ceil(_this.total/_this.pageSize) == _this.pageIndex) {
								_this.loadingFlag = false;
							} else {
								_this.loadingFlag = true;
							}
						} else {
							_this.loadingFlag = false;
							_this.show = false;
							document.getElementById('area_edu_table').innerHTML = '<div class="none_data"><img src="' + require("../../assets/img/none_icon.png") + '"><p style="color: #49b9ff">暂无数据</p></div>';
						}
						_this.pageIndex = _this.pageIndex + 1;
					}
				})
			}
		},
		close_window() {
			this.$emit("closeWin");
		}
	}
}
</script>
<style lang="scss">
#area_dialog {
	width: 100%;
	height: 100%;
	position: fixed;
	background: rgba(0, 0, 0, 0.6);
	padding: 0 !important;
	top: 0;
	left: 0;
	z-index: 999;

	.windows_table {
		width: 1000px;
		height: 700px;
		position: fixed;
		padding-top: 0.1rem;
		top: 200px;
		left: 50%;
		margin-Left: -500px;
		z-index: 9999;
		background-image: linear-gradient(135deg, #16304d, #060816);
		border-radius: 0.1rem;
		border: 1px solid #004774;
		box-shadow: 0 0 0.2rem #0075be;

	}

	.close_btn {
		position: absolute;
		width: 0.4rem;
		right: 0.15rem;
		top: 0.15rem
	}

	.close_btn img {
		width: 100%;
	}

	.close_btn:hover {
		cursor: pointer;
	}

	.opentab-header {
		width: 100%;
		height: 15%;
		text-align: center;
		background: url("../../assets/img/cam_titbgsmall03.png") center no-repeat;
		background-size: 100%;
		color: #34deff;
		font-size: 0.2rem;
		font-weight: bold;
		height: 0.8rem;
		line-height: 0.6rem;
	}

	.scroll_table {
		width: 100%;
		height: 7.8rem;
	}

	.scroll_table .leavelist .header {
		background: none;
		border-bottom: 1px solid #005b94;
		color: #06d2ff;
		font-size: 0.2rem;
		font-weight: bold;
	}

	.scroll_table .leavelist .row-item {
		color: #49b9ff;
		font-size: 0.2rem;
	}

	.none_data {
		text-align: center;
		font-size: 0.3rem;
		height: 100%;
		padding-top: 100px;
	}

	.none_data img {
		width: 3rem;
	}

	.none_data p {
		line-height: 1rem;
	}

	// 表格样式
	.pure-table {
		border-collapse: collapse;
		border-spacing: 0;
		empty-cells: show;
		font-size: 0.2rem;
		width: 100%;
		table-layout: fixed;
	}

	.pure-table thead tr {
		background-image: linear-gradient(135deg, #16304d, #0d192d);
		z-index: 2;
	}

	.pure-table tr>th {
		top: 0;
		z-index: 2;
		position: sticky;
		background: #16304d;
		color: #06d2ff;
		padding: .25rem 0rem;
		border-bottom: 1px solid #005b94;
	}

	.pure-table td {
		text-align: center;
		margin: 0;
		overflow: visible;
		padding: .25rem 0rem;
	}

	.pure-table tr:nth-child(2n) {
		background: #152542;
	}

	.pure-table td {
		background-color: transparent;
		color: #49b9ff;
	}

	.open_table {
		height: 565px;
		overflow-y: auto;
	}

	.count_tip {
		width: 100%;
		line-height: 0.8rem;
		position: absolute;
		bottom: 0;
		left: 0;
		text-align: center;
		color: #49b9ff;
		text-align: center;
		font-size: 0.2rem;
	}

	.open_table::-webkit-scrollbar {
		width: 2px;
	}

	.open_table::-webkit-scrollbar-thumb {
		border-radius: 30%;
		background: linear-gradient(to bottom, rgba(16, 221, 191, 0.1), rgba(27, 118, 103, 0.1), rgba(20, 195, 221, 0.1));
	}

	.open_table::-webkit-scrollbar-track {
		border-radius: 30%;
		background: linear-gradient(to bottom, rgba(20, 195, 221, 0), rgba(11, 252, 252, 0.1), rgba(20, 195, 221, 0));
	}
}
</style>